import { useQuery } from '@tanstack/react-query';
import { AGREEMENTS_TO_ACCEPT_KEY } from '../../utils/constants/queryKeys';
import { getAgreementsToAccept } from '../services/fn-api/Agreements';

export const useGetAgreementsToAccept = () => {
  return useQuery({
    queryKey: [AGREEMENTS_TO_ACCEPT_KEY],
    queryFn: () => getAgreementsToAccept(),
    retry: false,
  });
};
